
import Vue from "vue";
export default Vue.extend({
  created() {
    location.href = this.$route.query.oauth_url;
  },
});
